// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2jjP3","content":"Consent_content__2bRoY","footer":"Consent_footer__1tMyN"};